import formatPhone from './formatPhoneForUser';
/* eslint-disable no-param-reassign */
/* eslint-disable no-use-before-define */
const formatPhoneOrEmailBasic = (input) => {
	if (!input) return '';

	// remove any non alphanumeric characters
	const safeSearchTerm = input.replace(/\s/g, '').replace(/[^\w\s]/gi, '');

	const isNum = /^\d+$/.test(safeSearchTerm);

	// if is num, format as a phone number
	// else leave alone as assume it's an email
	return isNum ? formatPhone(input) : input.replace(/ /g, '');
};

export default formatPhoneOrEmailBasic;
